import React from "react";
import { BookOpenIcon, ClockIcon, FlameIcon, HelpCircleIcon, MessageCircleIcon, RefreshCwIcon } from "lucide-react";
import { CtaButton } from "../CtaButton";
import { SectionHeading } from "../SectionHeading";
import { painPoints } from "../../data/landingContent";
const iconMap = {
  flame: FlameIcon,
  clock: ClockIcon,
  help: HelpCircleIcon,
  books: BookOpenIcon,
  message: MessageCircleIcon,
  refresh: RefreshCwIcon
};
export function PainPointsSection() {
  return <section className="bg-white px-4 py-14 sm:py-20" data-id="element-246" data-mp="nw1x5dy1q2sv">
      <SectionHeading eyebrow="Does any of this sound familiar?" title="If you've experienced any of these situations, I created this system with you in mind." data-id="element-247" data-mp="nwlgmz3cgz90" />
      <div className="mx-auto mt-10 grid max-w-5xl grid-cols-1 gap-4 md:grid-cols-2" data-id="element-248" data-mp="xvamtulvov9f">
        {painPoints.map(p => {
        const Icon = iconMap[p.icon];
        return <article key={p.title} className="flex gap-4 rounded-2xl bg-blush/60 p-5" data-id="element-249" data-mp="298v727cyz1bj">
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-plum" data-id="element-250" data-mp="2r3jayy6u2qv3">
                <Icon className="h-5 w-5 text-white" aria-hidden="true" data-id="element-251" data-mp="2n16aopauvl5p" />
              </span>
              <div data-id="element-252" data-mp="2i1tjxtgv5txu">
                <h3 className="font-serif text-xl font-bold leading-snug text-ink" data-id="element-253" data-mp="2i11r2qeniab9">{p.title}</h3>
                <p className="mt-2 text-[16px] leading-relaxed text-muted" data-id="element-254" data-mp="2d27194i9nlhn">{p.body}</p>
              </div>
            </article>;
      })}
      </div>
      <CtaButton className="mt-10" label="I want to stop starting from zero" data-id="element-255" data-mp="23dgm0qy7u10p" />
    </section>;
}